import { useState } from 'react'
import { useMessageData } from '@hooks'
import NotificationPopup from '@components/NotificationPopup/NotificationPopup'
import { AutostartFeature, GameUIMessageType } from 'game-ui-types'
import FreespinsPressStartCounter from './FreespinsPressStartCounter'
import { useFreeSpinsBonusesStore } from '@stores/freeSpinsBonusesStore'
import { useUltraPlayStore } from '@stores/ultraPlayStore'

type MessageType = 'pressStartCounter' | 'notificationPopUp'

const FeatureAutostartCounterController = () => {
    const isUltraPlayOpen = useUltraPlayStore((s) => s.isOpen)

    const stopCounterMessages = [
        GameUIMessageType.FREESPINS_SPLASH_ENDED,
        GameUIMessageType.FEATURE_AUTOSTART_COUNTER_ENDED,
        GameUIMessageType.HOLD_AND_SPIN_PRESS_START_BUTTON_CLICKED,
    ]

    const [feature, setFeature] = useState<AutostartFeature>()
    const [messageType, setMessageType] = useState<MessageType>()
    const [seconds, setSeconds] = useState(15)

    const setIsFreespinsPressStartCounterActive = useFreeSpinsBonusesStore(
        (state) => state.setIsFreespinsPressStartCounterActive
    )

    useMessageData(({ type, payload }) => {
        if (type === GameUIMessageType.FEATURE_AUTOSTART_COUNTER_STARTED) {
            setFeature(payload?.feature)
            setMessageType(payload?.messageType)
            setSeconds(payload?.seconds ?? 15)
        }

        if (stopCounterMessages.includes(type)) {
            setMessageType(undefined)
        }
    }, [])

    if (feature === 'freespins' && messageType === 'pressStartCounter') {
        setIsFreespinsPressStartCounterActive(true)

        return <FreespinsPressStartCounter duration={seconds * 1000} />
    }

    if (messageType === 'notificationPopUp' && !isUltraPlayOpen) {
        return <NotificationPopup shouldShow={true} duration={seconds * 1000} type={feature} />
    }

    return
}

export default FeatureAutostartCounterController
